<form
    [formGroup]="form"
    class="input-grid-gaps grid-6col mt-1"
>
    <app-date-input
        id="validFrom"
        class="fr-2"
        label="person.restriction.fields.validFrom"
        [form]="form"
    ></app-date-input>

    <app-date-input
        id="validTo"
        class="fr-2"
        label="person.restriction.fields.validTo"
        [form]="form"
        timeType="endOfDay"
    ></app-date-input>

    <app-select-input
        id="restrictionType"
        class="fr-3"
        label="person.restriction.fields.restrictionType"
        [form]="form"
        [staticOptions]="personRestrictionEnumOptions"
        valueKey="value"
        [autoDisplayFirst]="true"
    ></app-select-input>

    <!-- Authorized person contact info -->
    <div class="fr-6">
        @if (form.value.restrictionType) {
            {{ ('person.enum.authorization.' + form.value.restrictionType) | translate }}:
        }
    </div>

    <div
        [ngClass]="{
        'fr-6': !selectedUserId(),
        'fr-2': selectedUserId(),
    }">
        <app-inner-modal
            #selectExistingModal
            [header]="'inputs.selectUser' | translate"
        >
            <div class="flex flex-column gap">
                <app-select-user
                    id="existingUserId"
                    [form]="form"
                    (userSelected)="updateFormWithSelectedUser($event)"
                    class="pt-2"
                >
                </app-select-user>
                <app-action-buttons
                    primaryButtonLabel="common.select"
                    (primaryClickEvent)="select($event)"
                    [primaryButtonDisability]="!form.value.existingUserId"
                    [secondaryButtonVisibility]="false"
                ></app-action-buttons>
            </div>
        </app-inner-modal>
    </div>

    @if (selectedUserId()) {
        <div class="flex gap-small align-items-center fr-4">
            <span class="font-bold align-self-center">{{ selectedUserName }}</span>
            @if (!restriction) {
                <app-button
                    icon="pi-times"
                    severity="danger"
                    [rounded]="true"
                    [text]="true"
                    (clickEvent)="deselect()">
                </app-button>
            }
        </div>
    }

    @if (!selectedUserId()) {
        <app-text-input
            id="titlesBefore"
            class="fr-1"
            [form]="form"
        ></app-text-input>

        <app-text-input
            id="name"
            class="fr-2"
            [form]="form"
        ></app-text-input>

        <app-text-input
            id="surname"
            class="fr-2"
            [form]="form"
        ></app-text-input>

        <app-text-input
            id="titlesAfter"
            class="fr-1"
            [form]="form"
        ></app-text-input>

        <app-phone-input
            id="mobile"
            class="fr-2"
            icon="pi-mobile"
            [form]="form"
        ></app-phone-input>

        <app-phone-input
            id="phone"
            class="fr-2"
            [form]="form"
        ></app-phone-input>

        <app-email-input
            id="email"
            class="fr-2"
            [label]="'inputs.email' | translate"
            [form]="form"
        ></app-email-input>

        <app-address-input
            id="address"
            class="fr-6"
            [form]="form"
        ></app-address-input>
    }

    <!-- Additional info for court appointed person -->
    @if (form.value.restrictionType === RestrictionEnum.GUARDIAN_APPROVED
        || form.value.restrictionType === RestrictionEnum.REPRESENTATIVE_APPROVED
        || form.value.restrictionType === RestrictionEnum.SUPPORTER_APPROVED
    ) {
        <div class="fr-6">
            {{ 'person.restriction.additionalInfoForJudistical' | translate }}:
        </div>

        <app-text-input
            id="basis"
            class="fr-2"
            label="person.restriction.fields.basis"
            [form]="form"
        ></app-text-input>

        <app-text-input
            id="referenceNumber"
            class="fr-2"
            label="person.restriction.fields.referenceNumber"
            [form]="form"
        ></app-text-input>

        <app-check-input
            id="isRelative"
            class="fr-2"
            label="person.restriction.fields.isRelative"
            [form]="form"
        ></app-check-input>
    }


    <!-- Additional info for municipal worker -->
    @if (form.value.restrictionType === RestrictionEnum.MUNICIPALITY_WORKER) {
        <div class="fr-6">
            {{ 'person.restriction.additionalInfoForMunicipal' | translate }}:
        </div>

        <app-select-input
            id="municipality"
            class="fr-4"
            label="person.restriction.fields.municipality"
            [form]="form"
            [infiniteScroll]="store.municipalityScroll"
            [valueKey]="'id'"
            [labelKey]="'name'"
            [filterBy]="'name'"
        ></app-select-input>
    }

    <app-text-input
        id="note"
        class="fr-6"
        [form]="form"
    ></app-text-input>
</form>
